import {Button, HeaderTitle, Breadcrumb} from '@/components/atoms'
import {TabsComponent} from '@/components/molecules'
import {OrderDigitalPayment, OrderInfo, OrderPriceInfo, OrderSoldTo} from '@/containers'
import OrderDetailsJSON from '@/services/MockData/Order/OrderDetail/OrderDetail.json'
import OrderDigitalPaymentJSON from '@/services/MockData/Order/OrderDigitalPayment/OrderDigitalPayment.json'
import OrderSoldToJSON from '@/services/MockData/Order/OrderSoldTo/OrderSoldTo.json'
import OrderPriceInfoJSON from '@/services/MockData/Order/OrderPriceInfo/OrderPriceInfo.json'

const TabList = [
  {
    tabLabel: 'Order Information',
    id: '1',
    tabComponent: <OrderInfo OrderDetails={OrderDetailsJSON[0]} />,
  },
  {
    tabLabel: 'Items',
    id: '2',
    tabComponent: <></>,
  },
  {
    tabLabel: 'Price Information',
    id: '3',
    tabComponent: <OrderPriceInfo OrderDetails={OrderPriceInfoJSON[0]} />,
  },
  {
    tabLabel: 'Sold To',
    id: '4',
    tabComponent: <OrderSoldTo OrderDetails={OrderSoldToJSON[0]} />,
  },
  {
    tabLabel: 'Digital Payment',
    id: '5',
    tabComponent: <OrderDigitalPayment OrderDetails={OrderDigitalPaymentJSON[0]} />,
  },
]

export const OrderDetail = () => {
  return (
    <>
      <div className="flex flex-row justify-between">
        <Breadcrumb
          uiSchema={{
            breadcrumbs: [
              {
                href: '/',
                label: 'Home',
              },
              {
                href: '/?path=/docs/molecules-dropdown--docs',
                label: 'Online Order',
              },
              {
                href: '/?path=/docs/molecules-breadcrumb--docs',
                label: OrderDetailsJSON[0].id,
              },
            ],
          }}
          id={'od_bradcrumb'}
        />
      </div>
      <div className="flex flex-row gap-4">
        <div className="flex">
          <HeaderTitle
            title={`${OrderDetailsJSON[0].id}`}
            className="mb-3 justify-start text-3xl font-bold text-slate-200"
          />
        </div>
        <div className="flex">
          <Button
            uiSchema={{
              title: 'Cancelled',
              variant: 'danger',
            }}
          />
        </div>
      </div>
      <TabsComponent tabList={TabList} defaultTabIndex={0} />
    </>
  )
}
